<template>
  <div class="gray-page">
    <PanelBox title="水杯信息" hidden_desc>
      <div class="cup-info">
        <img :src="info.image" />
        <div class="info">
          <div class="cup-name">{{info.name}}</div>
          <div class="wechatNumber">{{info.cup_sn}}</div>
        </div>
      </div>
    </PanelBox>
    <PanelBox title="选择模式" :desc="desc1">
      <ModelList :list="list" :choice.sync="choice" @Toast="Toast" />
    </PanelBox>
    <PanelBox title="完善信息" :desc="desc2">
      <FormPanel ref="FormPanel" :choice="choice" :schoolname="schoolname" />
    </PanelBox>
    <Btn title="保存" style="margin-top: 1.68rem;" @click="bindCup" />
  </div>
</template>

<script>
  import PanelBox from './components/PanelBox'
  import ModelList from './components/ModelList'
  import FormPanel from './components/FormPanel'
  export default {
    data () {
      return {
        desc1: [
          '1、您可选择一个已购买的模式与该水杯编号进行绑定，一旦绑定，不可解绑。',
          '2、一个模式使用完以后，可以选择另外的模式。'
        ],
        desc2: [
          '用户需完善使用者信息才能使用该水杯，激活水杯后信息不可修改。'
        ],
        info: {},
        list: [],
        choice: 0,
        schoolInfo: {
          class: []
        },
        schoolname: '',
        school_id: '',
        deposit_text: ''
      }
    },
    methods: {
      getPlanList () {
        this.$Get('Common.getPlanList', {
          cup_sn: this.$route.query.cup_sn
        }).then(res => {
          this.deposit_text = res.data.deposit_text
          this.info = res.data
          this.list = res.data.planList
          // this.schoolname = res.data.school_name
          // this.$CodeValue.Class = res.data.classList.map(item => ({ ...item, code: item.id, value: item.name }))
          if (!this.list.length) {
            this.$ShowConfirm(
              '该账户暂无选购模式，请联系学校选购模式后再添加水杯绑定！',
              {
                title: '温馨提示',
                showCancel: false,
                confirmText: '我知道了'
              }
            ).then(() => {
              this.$nav('Common.Home')
            })
          }
        })
      },
      getSchool () {
        this.$Get('Common.getSchool', {
          plan_id: this.choice
        }).then(res => {
          this.schoolInfo = res.data
          this.schoolname = res.data.name
          this.school_id = res.data.id
          this.$CodeValue.School = [res.data].map(item => ({ ...item, code: item.id, value: item.name }))
          this.$CodeValue.Class = res.data.class.map(item => ({ ...item, code: item.id, value: item.name }))
        })
      },
      bindCup () {
        const FormPanel = this.$refs['FormPanel']
        this.$Post('Common.bindCup', {
          cup_sn: this.$route.query.cup_sn,
          plan_id: this.choice,
          school_id: this.school_id,
          student_name: FormPanel.name,
          student_gender: FormPanel.sex,
          class_id: FormPanel.class_choice,
          kinship: FormPanel.family_choice
        }).then(res => {
          console.log("res--:",res)
          this.$ShowToast('保存成功', { icon: 'success' }).then(() => {
            // this.$nav('back', 2)
            console.log("保存成功----")
            this.$nav('Common.Home',{},{
              openType:'redirectTo'
            })
          })
        })
      },
      Toast () {
        this.$ShowConfirm(this.deposit_text, {
          title: '押金说明',
          showCancel: false,
          messageAlign: 'left',
          confirmText: '我知道了'
        })
      }
    },
    watch: {
      choice () {
        this.getSchool()
      }
    },
    created () {
      this.getPlanList()
    },
    components: {
      PanelBox,
      ModelList,
      FormPanel
    }
  }
</script>

<style lang="less" scoped>
  .gray-page {
    .p(.3rem .24rem .9rem);
    .cup-info {
      display: flex;
      .mt(.36rem);
      .pb(.3rem);
      align-items: center;
      img {
        .w(1rem);
        .h(1rem);
        .br(.1rem);
        .mr(.3rem);
      }
      .cup-name {
        .fz(.3rem);
        .c(#333);
        .mb(.18rem);
        font-weight: bold;
      }
      .wechatNumber {
        .fz(.28rem);
        .c(#333);
        font-weight: bold;
      }
    }
  }
</style>
